export default "__VITE_ASSET__954f7070__"